import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-6 py-2 bg-white border-b-4" }

import {useStore} from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const store = useStore()
const useSideBar = () => store.commit("sideBar/useSideBar")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", { class: "flex items-center" }, [
      _createElementVNode("button", {
        onClick: useSideBar,
        class: "text-gray-500 focus:outline-none"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          class: "w-6 h-6",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M4 6H20M4 12H20M4 18H11",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)
      ]))
    ])
  ]))
}
}

})